<script lang="ts">
  import { createEventDispatcher, tick } from 'svelte';
  import Icon from '$shared/icons/Icon.svelte';

  export let action: string;
  export let durationSeconds: number | null = null;
  export let editable = false;
  export let label = 'Duration';
  export let placeholder = 'Click to set duration';
  export let minutesText = 'minutes';

  const dispatch = createEventDispatcher();
  let minutes = durationSeconds ? Math.round(durationSeconds / 60) : 0;
  let editing = false;
  let input: HTMLInputElement;
  let timer: ReturnType<typeof setTimeout>;

  // Opens the minutes box with the cursor in it.
  async function edit() {
    editing = true;
    await tick();
    input.focus();
  }

  // Keeps digits only, and closes the box a moment after typing stops, which saves it.
  function handleInput() {
    input.value = input.value.replace(/\D/g, '');
    minutes = Number(input.value);
    dispatch('change');
    clearTimeout(timer);
    timer = setTimeout(() => input.blur(), 1000);
  }

  // Saves the time in seconds and passes the response up for "Saved" and the total.
  async function save() {
    clearTimeout(timer);
    const response = await fetch(action, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      },
      body: JSON.stringify({ question_set: { duration: minutes * 60 } }),
    });
    if (response.ok) dispatch('saved', await response.json());
  }
</script>

<div class="flex items-center gap-2">
  <span>{label}:</span>
  {#if editing}
    <input bind:this={input} value={minutes || ''} inputmode="numeric" class="w-16 px-2 py-0 rounded border border-neutral-300"
      on:input={handleInput} on:blur={() => { save(); editing = false; }} />
    <span>{minutesText}</span>
  {:else}
    <button type="button" class="group relative" disabled={!editable} on:click={edit}>
      <span class="inline-block group-hover:pl-6 transition-all" class:text-neutral-400={!minutes}>
        {minutes ? (minutes >= 60 ? `${Math.floor(minutes / 60)}h ${minutes % 60}m` : `${minutes}m`) : placeholder}
      </span>
      <span class="absolute left-0 top-0 h-full flex items-center opacity-0 group-hover:opacity-100"><Icon icon="Edit" size="small" /></span>
    </button>
  {/if}
</div>
